@if (state(); as s) {
  <div class="justup-card-tiny net" [class.net--offline]="s === 'offline'" [class.net--back]="s === 'back'"
       data-testid="network-status" [attr.data-state]="s" [attr.role]="s === 'offline' ? 'alert' : 'status'">
    <mat-icon class="net__icon" [class.ink-error]="s === 'offline'" [class.ink-valid]="s === 'back'" aria-hidden="true">{{ icon() }}</mat-icon>
    <span class="flex-col net__text">
      <span class="body-2 on-background">{{ title() | trans }}</span>
      <span class="caption on-background-alt">{{ detail() }}</span>
    </span>
    @if (s === 'offline') {
      <vl-chips data-testid="btn-network-retry" size="small" iconLeft="refresh" [loading]="network.probing()"
                [ariaLabel]="'system.network.retry' | trans" (action)="retry()">{{ 'system.network.retry' | trans }}</vl-chips>
    }
  </div>
}
